import { redirect } from 'react-router';

import { RequireAuthentication } from 'containers/RequireAuthentication';
import { getHorizonUserEnvironmentPromiseFromContext } from 'horizon/utils/getHorizonUserEnvironmentPromiseFromContext';
import { isRenderingHorizonServer } from 'rendering/state/renderingState';
import type { HorizonAppRouteLoaderArgs } from 'routing/classes/types/AppRouteLoaderArgs';
import { emailRateRecommendedCandidateRoute } from 'routing/routes';
import type { HorizonAppRouteComponentProps } from 'routing/types/HorizonAppRouteComponentProps';

import { RateRecommendedCandidateLoadable } from './RateRecommendedCandidateLoadable';

export async function loader({
  request,
  context,
}: HorizonAppRouteLoaderArgs<typeof emailRateRecommendedCandidateRoute>) {
  if (isRenderingHorizonServer()) {
    const userEnvironment = await getHorizonUserEnvironmentPromiseFromContext({
      request,
      context,
    });

    if (!userEnvironment.user) return redirect('/login');
  }

  await RateRecommendedCandidateLoadable.load();
}

export default function OrgDashboardRateRecommendedCandidateHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return (
    <RequireAuthentication>
      <RateRecommendedCandidateLoadable />
    </RequireAuthentication>
  );
}
